import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {BusinessService} from '@mpt-fo/common/core/services/business.service';
import {ProfileService} from '@mpt-fo/common/core/services/profile.service';
import {ScreenManagerService} from '@mpt-fo/common/core/services/screen-manager.service';
import {ModalService} from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { DialogMessageType } from '@mpt-fo/common/shared/models/utility.model';
import {BusinessPinComponent} from '../../business-pin.component';

@Component({
	selector: 'app-business-pin-mobile',
	templateUrl: './business-pin-mobile.component.html',
	styleUrls: ['./business-pin-mobile.component.scss']
})
export class BusinessPinMobileComponent extends BusinessPinComponent implements OnInit {
	mobileMessageType: DialogMessageType;
	constructor(
		screenManager: ScreenManagerService,
		fb: FormBuilder,
		router: Router,
		businessService: BusinessService,
		profileService: ProfileService,
		modalService: ModalService) {
		super(screenManager, fb, router, businessService, profileService, modalService);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.initialize();
	}

}
